import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
{
  path: '',
  redirectTo: '/home',
  pathMatch: 'full'
},

  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
  },
  {
    path: 'loader',
    loadChildren: () => import('./loader/loader.module').then( m => m.LoaderPageModule)
  },
  {
    path: 'reclamaciones',
    loadChildren: () => import('./componentes/pages/reclamaciones/reclamaciones.module').then( m => m.ReclamacionesPageModule)
  },
  {
    path: 'comosehace/:key',
    loadChildren: () => import('./componentes/pages/comosehace/comosehace.module').then( m => m.ComosehacePageModule)
  },
  {
    path: 'terminos',
    loadChildren: () => import('./componentes/pages/terminos/terminos.module').then( m => m.TerminosPageModule)
  },
  {
    path: 'politicaprivacidad',
    loadChildren: () => import('./componentes/pages/politicaprivacidad/politicaprivacidad.module').then( m => m.PoliticaprivacidadPageModule)
  },
  {
    path: 'politicadevoluciones',
    loadChildren: () => import('./componentes/pages/politicadevoluciones/politicadevoluciones.module').then( m => m.PoliticadevolucionesPageModule)
  },
  {
    path: 'principal',
    loadChildren: () => import('./componentes/pages/principal/principal.module').then( m => m.PrincipalPageModule)
  },
 {
    path: 'comosehace',
    loadChildren: () => import('./componentes/pages/comosehace/comosehace.module').then( m => m.ComosehacePageModule)
  },
  {
    path: 'viewallpeluches',
    loadChildren: () => import('./componentes/pages/viewallpeluches/viewallpeluches.module').then( m => m.ViewallpeluchesPageModule)
  },
  {
    path: 'agregaraudio',
    loadChildren: () => import('./componentes/agregaraudio/agregaraudio.module').then( m => m.AgregaraudioPageModule)
  },
  {
    path: 'viewallflowers',
    loadChildren: () => import('./componentes/pages/viewallflowers/viewallflowers.module').then( m => m.ViewallflowersPageModule)
  },
  {
    path: 'peluche',
    loadChildren: () => import('./componentes/pages/peluche/peluche.module').then( m => m.PeluchePageModule)
  }
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
